// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, Promise] = chunk loading, 0 = chunk loaded
const installedChunks = {
	"@templates/syllabus@2026": 0,
	"web": 0,
	"sec": 0,
	"dev": 0,
	"bdd": 0,
	"web/SAE4-02-VCOD": 0,
	"web/R5-07-VCOD": 0,
	"web/R4-09-VCOD": 0,
	"web/R3-03": 0,
	"sec/S5-07-B": 0,
	"sec/S5-07-A": 0,
	"sec/R4-10-VCOD": 0,
	"sec/R3-12-VCOD": 0,
	"sec/R2-14": 0,
	"sec/R1-11": 0,
	"dev/R6-01-VCOD": 0,
	"dev/R5-06-VCOD-B": 0,
	"dev/R5-06-VCOD-A": 0,
	"dev/R4-01": 0,
	"bdd/R1-02": 0,
	"bdd/R1-01": 0,
	"acc/R1-13": 0
};

const installChunk = (data) => {
	let {__webpack_esm_ids__, __webpack_esm_modules__, __webpack_esm_runtime__} = data;
	// add "modules" to the modules object,
	// then flag all "ids" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	for(moduleId in __webpack_esm_modules__) {
		if(__webpack_require__.o(__webpack_esm_modules__, moduleId)) {
			__webpack_require__.m[moduleId] = __webpack_esm_modules__[moduleId];
		}
	}
	if(__webpack_esm_runtime__) __webpack_esm_runtime__(__webpack_require__);
	for(;i < __webpack_esm_ids__.length; i++) {
		chunkId = __webpack_esm_ids__[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}

}

// no chunk on demand loading

// no prefetching

// no preloaded

__webpack_require__.C = installChunk;

// no on chunks loaded
// no HMR

// no HMR manifest